import { Button } from "@datapay-by-datacom/design-system";
import type {
  NormalisationIssue,
  NormalisationRunBlocked,
} from "../types/normalisationRun";
import s from "./NormalisationBlockedPanel.module.css";

export interface NormalisationBlockedPanelProps {
  result: NormalisationRunBlocked;
  onReturnToUpload: () => void;
  onDownloadIssues: () => void;
  isDownloadingIssues?: boolean;
}

function issueHeadline(issue: NormalisationIssue): string {
  if (issue.title !== undefined && issue.title.trim() !== "") {
    return issue.title;
  }
  return issue.code;
}

/** CN-07 — run blocked; issues export only (no detail/summary CSV or totals). */
export function NormalisationBlockedPanel({
  result,
  onReturnToUpload,
  onDownloadIssues,
  isDownloadingIssues = false,
}: NormalisationBlockedPanelProps) {
  const issueCount = result.issues.length;

  return (
    <section
      className={s.section}
      aria-labelledby="normalisation-blocked-heading"
    >
      <h2 id="normalisation-blocked-heading" className={s.heading}>
        Normalisation blocked
      </h2>
      <p className={s.subtitle}>
        {issueCount} blocking {issueCount === 1 ? "issue" : "issues"} · CSV
        download unavailable
      </p>

      <div className={s.errorBanner} role="alert">
        <span className={s.blockingPill}>Blocking</span>
        Fix the PDF or source layout, then re-upload.
      </div>

      <div className={s.issueClusters} role="list">
        {result.issues.map((issue, index) => (
          <div
            key={`${issue.code}-${index}`}
            className={s.issueCluster}
            role="listitem"
          >
            <strong className={s.issueTitle}>{issueHeadline(issue)}</strong>
            <p className={s.issueDetail}>{issue.message}</p>
          </div>
        ))}
      </div>

      <div className={s.actions}>
        <Button variant="primary" isDisabled>
          Download Component CSV
        </Button>
        <Button variant="primary" isDisabled>
          Download Gross CSV
        </Button>
        <Button variant="primary" isDisabled>
          Download Super CSV
        </Button>
        <Button
          variant="secondary"
          onPress={onDownloadIssues}
          isDisabled={isDownloadingIssues}
        >
          Download issues export
        </Button>
        <Button variant="secondary" onPress={onReturnToUpload}>
          Return to upload
        </Button>
      </div>
    </section>
  );
}
